import { createSlice } from '@reduxjs/toolkit';
import { findServiceCategory } from './api';
import { initialState } from './api/interface';

const serviceCategorySlice = createSlice({
  name: 'serviceCategory',
  initialState,
  reducers: {
    setLimit: (state, action) => {
      state.limit = action.payload.limit;
      state.status = 'idle';
    },
    setSkip: (state, action) => {
      state.skip = action.payload.skip;
      state.status = 'idle';
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload.currentPage;
    },
    setStatus: (state, action) => {
      state.status = action.payload.status;
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(findServiceCategory.pending, (state) => {
      state.isLoading = true;
      state.status = 'pending';
    });
    builder.addCase(findServiceCategory.fulfilled, (state, action) => {
      state.data = action.payload.data;
      state.totalRecords = action.payload.total;
      state.isLoading = false;
      state.status = 'succeeded';
    });
    builder.addCase(findServiceCategory.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
      state.status = 'failed';
    });
  },
});

export const { setLimit, setSkip, setCurrentPage, setStatus, reset } =
  serviceCategorySlice.actions;
export default serviceCategorySlice.reducer;
